<template>
  <div class="item" id="examples2">
      <div class="item-header">
        <div class="item-header-title">OUR CUSTOMERS</div>
        <div class="item-header-name">
          <span class="item-header-name-line" />
          <span>服务</span>
          <span class="bold">案例</span>
          <span class="item-header-name-line" />
        </div>
        <div class="item-header-desc">值得信赖的专业数据中心技术服务提供商</div>
      </div>

      <div class="item-content">
        <Message />
      </div>
    </div>
</template>

<script>
import Message from '../../components/Message'
export default {
  components: {
    Message
  }
}
</script>

<style lang="less" scoped>
.item-content {
  width: 100%;
}
</style>